export default class TokenIsExpiredError extends Error {
    constructor(message = 'Token is expired', ...args) {
        super(message, ...args);
    }
}
